import { TELEMETRY_ROUTE_VALUES, TELEMETRY_STORES } from "./telemetry-broker.js";
import { z } from "zod";
//#region src/telemetry-broker.schemas.ts
/**
* Zod schemas of the telemetry read path. The constants, the types and the check functions are in
* `telemetry-broker.ts`.
*/
/** Accepts exactly one of `TELEMETRY_STORES`, as spelled. Any other value fails. */
const TelemetryStoreSchema = z.enum(TELEMETRY_STORES);
/** Accepts exactly `dp` or `fleet`, as spelled. Any other value, a case variant included, fails. */
const TelemetryRouteValueSchema = z.enum(TELEMETRY_ROUTE_VALUES);
//#endregion
export { TelemetryRouteValueSchema, TelemetryStoreSchema };

//# sourceMappingURL=telemetry-broker.schemas.js.map